import { Injectable } from '@angular/core';
import { FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class FormService {

  constructor() { }

  // Método para aplicar validadores a un formulario
  applyValidators(form: FormGroup, fieldValidators: Record<string, ValidatorFn[]>): void {
    Object.keys(fieldValidators).forEach(field => {
      const control = form.get(field);
      if (control) {
        control.setValidators(fieldValidators[field]);
        control.updateValueAndValidity();
      }
    });
  }

  // Método para habilitar varios campos de un formulario
  enableFields(form: FormGroup, fields: string[]): void {
    fields.forEach(field => {
      const control = form.get(field);
      if (control) {
        control.enable();
      }
    });
  }

  // Método para deshabilitar varios campos de un formulario
  disableFields(form: FormGroup, fields: string[]): void {
    fields.forEach(field => {
      const control = form.get(field);
      if (control) {
        control.disable();
      }
    });
  }

  // Método para hacer que los campos sean requeridos
  setFieldsRequired(form: FormGroup, fields: string[]): void {
    fields.forEach(field => {
      const control = form.get(field);
      if (control) {
        control.setValidators([Validators.required]);
        control.updateValueAndValidity();
      }
    });
  }

  // Método para hacer que los campos sean opcionales
  setFieldsOptional(form: FormGroup, fields: string[]): void {
    fields.forEach(field => {
      const control = form.get(field);
      if (control) {
        control.clearValidators();
        control.updateValueAndValidity();
      }
    });
  }

  // Método para resetear el formulario a su estado inicial
  resetForm(form: FormGroup, initialValues: any = {}): void {
    form.reset(initialValues); // Resetea los valores del formulario
    Object.keys(form.controls).forEach(field => {
      form.get(field).clearValidators(); // Limpiar cualquier validador si es necesario
      form.get(field).updateValueAndValidity();
    });
  }

  resetFormMultiple(form: FormGroup, initialValues: any = {}): void {
    form.reset(initialValues); // Resetea los valores del formulario

    Object.keys(form.controls).forEach(field => {
        const control = form.get(field);

        if (control instanceof FormGroup) {
            // Si el control es un FormGroup, llama recursivamente
            this.resetForm(control, initialValues[field] || {});
        } else if (control instanceof FormControl) {
            // Si el control es un FormControl, limpia validadores y actualiza
            control.clearValidators();
            control.updateValueAndValidity();
        }
    });
}

}
